import { useCallback, useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { FetchResult } from '@apollo/client';
import {
  UpdateUserPreferenceForTenantCollectorSettingMutation,
  UpdateUserPreferenceForTenantCollectorSettingInput,
  useUpdateUserPreferenceForTenantCollectorSettingMutation
} from 'graphql/types';
export const useUpdateUserPreferenceForTenantCollectorSetting = (): {
  updateUserPreferences: (
    input: UpdateUserPreferenceForTenantCollectorSettingInput
  ) => Promise<
    FetchResult<
      UpdateUserPreferenceForTenantCollectorSettingMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    updateUserPreferenceForTenantCollectorSettingMutation,
    { loading, error }
  ] = useUpdateUserPreferenceForTenantCollectorSettingMutation();

  const updateUserPreferences = useCallback(
    async (input: UpdateUserPreferenceForTenantCollectorSettingInput) =>
      await updateUserPreferenceForTenantCollectorSettingMutation({
        variables: {
          input
        }
      }),
    [updateUserPreferenceForTenantCollectorSettingMutation]
  );
  return useMemo(
    () => ({
      updateUserPreferences,
      loading,
      error
    }),
    [updateUserPreferences, loading, error]
  );
};
